import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "value-editor" }
const _hoisted_2 = { class: "rich-editor" }
const _hoisted_3 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_4 = { class: "d-flex justify-content-end my-3" }
const _hoisted_5 = { class: "suggestions-table-container" }
const _hoisted_6 = {
  key: 0,
  class: "suggestions-table table with-sticky-header"
}
const _hoisted_7 = { class: "value-header" }
const _hoisted_8 = { class: "count-header" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", { class: "check-header" }, null, -1)
const _hoisted_10 = { class: "table-body" }
const _hoisted_11 = {
  key: 0,
  class: "table-values-row"
}
const _hoisted_12 = { class: "table-values-cell quantity-cell" }
const _hoisted_13 = { class: "table-values-cell apply-cell" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "mdp-Check" }, null, -1)
const _hoisted_15 = { class: "m-0" }
const _hoisted_16 = { class: "ml-1" }
const _hoisted_17 = { class: "d-flex justify-content-end my-3" }
const _hoisted_18 = { class: "suggestions-table-container" }
const _hoisted_19 = {
  key: 0,
  class: "suggestions-table table with-sticky-header"
}
const _hoisted_20 = { class: "value-header" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("th", { class: "check-header" }, null, -1)
const _hoisted_22 = { class: "table-body" }
const _hoisted_23 = {
  key: 0,
  class: "table-values-row"
}
const _hoisted_24 = { class: "table-values-cell apply-cell" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "mdp-Check" }, null, -1)
const _hoisted_26 = { class: "m-0" }
const _hoisted_27 = { class: "ml-1" }
const _hoisted_28 = {
  key: 1,
  class: "spinner-container"
}

import CommonFilter from "@common/components/CommonFilter.vue";
import EmptyState from "@common/components/EmptyState.vue";
import HTMLEditor from "@common/components/HTMLEditor.vue";
import Spinner from "@common/components/Spinner.vue";
import { Language } from "@medapro-types/common/common";
import { RootState } from "@medapro-types/common/rootstate";
import { MasterDataTableModel } from "@medapro-types/ContentEditor/Article/MasterDataTableEditor";
import { AttributeValuesModel, DefaultAttributeUnit, DefaultAttributeValue, SuggestionsModel } from "@medapro-types/ContentEditor/content-editor-store";
import suggestApi from "@services/suggest.js";
import { NumberParser } from "@util/numberParse";
import _ from "lodash";
import moment from "moment";
import { Editor as TinymceEditor } from "tinymce";
import { ComputedRef, VNodeRef, computed, onBeforeUnmount, onMounted, reactive } from "vue";
import { useI18n } from "vue-i18n";
import { createNamespacedHelpers, useState } from "vuex-composition-helpers";
import { getLanguageDisplayName } from "../../util/languages";

//#region General
type ViewModel = {
  focused: Record<string, boolean>;
  editedValue: any;
  valueOrFallback: any;
  textAttributeSuggestionsEnabled: boolean;
  tableAttributeSuggestionsEnabled: boolean;
  globalAttributeSuggestionsEnabled: boolean;
  erpAttributeSuggestionsEnabled: boolean;
  suggestValues: SuggestionsModel[];
  defaultValues: Array<DefaultAttributeValue | DefaultAttributeUnit>;
  isBusy: boolean;
  suggestFilter: string;
  defaultFilter: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AttributeValueEditor',
  props: {
    editValue: {},
    visible: { type: Boolean },
    language: {},
    dataType: {},
    field: {},
    tooltipText: {},
    valueOrFallback: {},
    attributeType: {},
    attributeId: {},
    attributes: {},
    canEdit: { type: Boolean },
    defaultOnly: { type: [Boolean, null] }
  },
  emits: ["update:visible", "edited-value"],
  setup(__props: any, { emit }) {

const props = __props;




const placeholderVisible = () => {
  return (
    !viewModel.focused[`attribute-editor-${props.language.languageCode}`] && !props.editValue && props.valueOrFallback.isFallback && props.valueOrFallback.value
  );
};

const { t: $t } = useI18n();
//#endregion

//#region ViewModel
const viewModel = reactive<ViewModel>({
  focused: {},
  editedValue: "",
  valueOrFallback: {},
  textAttributeSuggestionsEnabled: false,
  tableAttributeSuggestionsEnabled: false,
  globalAttributeSuggestionsEnabled: false,
  erpAttributeSuggestionsEnabled: false,
  suggestValues: [],
  defaultValues: [],
  isBusy: false,
  suggestFilter: "",
  defaultFilter: ""
});

//#endregion

///article
const { useState: useArticleState } = createNamespacedHelpers("contentEditor/article");

const articleState = useArticleState(["masterdata"]) as {
  masterdata: ComputedRef<MasterDataTableModel>;
};
const masterdata = articleState.masterdata;

///userSettings
const { userSettings } = useState<RootState>(["userSettings"]);

//#region Tinymce
const richEditorToolTipText = computed(() => {
  let result = "";
  if (props.tooltipText) result += `${props.tooltipText}`;
  if (validationTooltipText.value) result += `${validationTooltipText.value}`;
  if (fallbackLanguageText.value) result += `${fallbackLanguageText.value}`;
  return result;
});
const canApplySuggests = computed(() => {
  return props.canEdit === true && !props.defaultOnly;
});
const canApplyDefaultValues = computed(() => {
  return props.canEdit === true;
});
const tinymceConfig = computed(() => {
  return {
    toolbar: getToolbar(),
    article_id: !_.isString(masterdata.value[props.language.languageCode]) ? masterdata.value[props.language.languageCode]?.articleId : "",
    language_code: props.language.languageCode,
    inherits: getInheritStatus()
  };
});

const editorRefs: Record<string, TinymceEditor> = {};

const assignEditorRefs = (el: TinymceEditor, languageCode: string): VNodeRef => {
  const key = `attribute-editor-${languageCode}`;
  editorRefs[key] = el;
  return key as VNodeRef;
};

const focusEditor = () => {
  const key = `attribute-editor-${props.language.languageCode}`;
  viewModel.focused[key] = true;
  const editor = editorRefs[key];
  editor.getEditor().focus(true);
};

const getInheritStatus = () => {
  const attributeType = props.attributeType;
  const attributes = props.attributes;
  if (!attributeType) return true;

  switch (attributeType) {
    case "invariantAttributes":
      return true;
    case "variantAttributes":
      return false;
    case "globalAttributes":
      return attributes?.[props.language.languageCode].inherits;
    default:
      return true;
  }
};

const getToolbar = () => {
  const { attributeType, field, attributes } = props;
  const languageCode = props.language.languageCode;

  const limittedToolbar =
    "fullscreen | bold italic underline | blocks | alignleft aligncenter alignright alignjustify | bullist numlist | subscript superscript | forecolor removeformat undo redo | outdent indent code | link";
  const completeToolbar = `${limittedToolbar} | smartsnippets`;

  const attributeTypesForSmartSnippets = ["invariantAttributes", "variantAttributes", "globalAttributes", "erpAttributes"];

  if (attributeTypesForSmartSnippets.includes(attributeType)) {
    if (field === "value" && !attributes?.[languageCode]?.defaultValueOnly) {
      return completeToolbar;
    } else if (field === "unit" && !attributes?.[languageCode]?.defaultUnitOnly) {
      return completeToolbar;
    }
  }

  return limittedToolbar;
};

const shouldShowSuggestions = () => {
  const attributeType = props.attributeType;
  if (!attributeType) return false;

  switch (attributeType) {
    case "invariantAttributes":
      return userSettings.value.IsTextAttributeSuggestionsEnabled == "true" || userSettings.value.IsTextAttributeSuggestionsEnabled == true;
    case "variantAttributes":
      return userSettings.value.IsTableAttributeSuggestionsEnabled == "true" || userSettings.value.IsTableAttributeSuggestionsEnabled == true;
    case "globalAttributes":
      return userSettings.value.IsGlobalAttributeSuggestionsEnabled == "true" || userSettings.value.IsGlobalAttributeSuggestionsEnabled == true;
    case "erpAttributes":
      return userSettings.value.IsERPAttributeSuggestionsEnabled == "true" || userSettings.value.IsERPAttributeSuggestionsEnabled == true;
    default:
      return false;
  }
};

const isReadOnly = () => {
  const { field, attributes, canEdit } = props;

  if (!canEdit) return true;

  const languageCode = props.language.languageCode;

  if (attributes?.[languageCode].dataType == "AttributeDataTypeLogical") {
    if (field === "value") return true;
  } else if (field === "value") return attributes?.[languageCode].defaultValueOnly;
  else if (field === "unit") return attributes?.[languageCode].defaultUnitOnly;

  return false;
};

const initialize = async () => {
  const _focused: Record<string, boolean> = {};
  const key = `attribute-editor-${props.language.languageCode}`;
  _focused[key] = false;
  viewModel.focused = _focused;
  viewModel.editedValue = props.editValue;
  viewModel.valueOrFallback = props.valueOrFallback;

  if (!shouldShowSuggestions() || !props.field || !props.attributeId) return;
  viewModel.isBusy = true;
  getDefaultValues();
  await getSuggestions();
  viewModel.isBusy = false;
};

const filteredDefaultValues = computed<Array<DefaultAttributeValue | DefaultAttributeUnit>>(() => {
  let baseList = viewModel.defaultValues;
  if (!_.isEmpty(viewModel.defaultFilter)) {
    const filter = viewModel.defaultFilter.toLocaleLowerCase();
    baseList = viewModel.defaultValues.filter((item) => item.value.toLocaleLowerCase().includes(filter));
  }

  return _.sortBy(baseList, ["sequence"]);
});

const getDefaultValues = async () => {
  const { field, attributes } = props;
  const languageCode = props.language.languageCode;
  if (field == "value" && attributes[languageCode].defaultValueOnly && attributes[languageCode].defaultValues.length > 0) {
    viewModel.defaultValues = attributes[languageCode].defaultValues;
  } else {
    await fecthDefaultValues();
  }

  if (field == "unit" && attributes[languageCode].defaultUnitOnly && attributes[languageCode].defaultUnits.length > 0) {
    viewModel.defaultValues = attributes[languageCode].defaultUnits;
  } else {
    await fecthDefaultValues();
  }
};

const fecthDefaultValues = async () => {
  try {
    viewModel.defaultValues = await suggestApi.suggest[props.attributeType][props.field].get(props.language.languageCode, props.attributeId, null, 100, true);
  } catch (error) {
    console.error("Failed to get default values for value editor", error);
  }
};

const filteredSuggestValues = computed<SuggestionsModel[]>(() => {
  let baseList = viewModel.suggestValues;
  if (!_.isEmpty(viewModel.suggestFilter)) {
    const filter = viewModel.suggestFilter.toLocaleLowerCase();
    baseList = viewModel.suggestValues.filter((item) => item.value.toLocaleLowerCase().includes(filter));
  }

  return _.sortBy(baseList, ["count", "sequence"]);
});

const getSuggestions = async () => {
  try {
    viewModel.suggestValues = await suggestApi.suggest[props.attributeType][props.field].get(props.language.languageCode, props.attributeId, null, 100, false);
  } catch (error) {
    console.error("Failed to get default values for value editor", error);
  }
};

const applySuggest = (value: string) => {
  const key = `attribute-editor-${props.language.languageCode}`;
  const editor = editorRefs[key];
  editor.getEditor().setContent(value);
  viewModel.editedValue = value;

  if (viewModel.focused[key] == false) viewModel.focused[key] = true;
};

const onOkButtonClicked = () => {
  if (!canApplySuggests.value && !canApplyDefaultValues.value) return;
  emit("edited-value", viewModel.editedValue);
  cleanupEditorInstance();
};

onMounted(() => {
  initialize();
  document.addEventListener("focusin", handleFocusIn);
});

onBeforeUnmount(() => {
  cleanupEditorInstance();
  document.removeEventListener("focusin", handleFocusIn);
});

const validationFeedback = computed(() => {
  const { field, dataType, attributes, language } = props;
  const value = viewModel.editedValue;
  let isEmptyValue = false;
  let notAllowedValue = false;
  let exceedsMaxLength = false;

  // Helper to check if the length exceeds a limit
  const lengthExceeds = (limit: number) => value && value.length > limit;

  const valueRequired = props.attributes[props.language.languageCode]?.valueRequired;
  const maxLength = props.attributes[props.language.languageCode]?.maximum;
  const maxLengthLimit = props.attributeType == "globalAttributes" ? 4000 : 1024;
  if (valueRequired && (value == null || value == "")) {
    isEmptyValue = true;
  } else if (value != null && value.length > (maxLength as number)) {
    exceedsMaxLength = true;
  }

  if (
    props.attributes[props.language.languageCode]?.defaultValueOnly &&
    props.attributes[props.language.languageCode]?.defaultValues != null &&
    props.attributes[props.language.languageCode]?.dataType != "AttributeDataTypeLogical"
  ) {
    notAllowedValue = (value && props.attributes[props.language.languageCode]?.defaultValues.every((x) => x.value != value)) as boolean;
  }

  // Helper to validate numerical types
  const isValidNumber = (parsedValue: number, originalValue: string, fractionDigits: number) =>
    originalValue === parser.parseNumberToLocaleString(parsedValue, { minimumFractionDigits: fractionDigits });
  // Check length constraints
  const msgforValue =
    (isEmptyValue &&
      $t("validation.valueRequired", {
        field: $t("value", 1)
      })) ||
    (exceedsMaxLength &&
      $t("validation.lengthExceeds", {
        field: $t("value", 1),
        length: maxLength
      })) ||
    (notAllowedValue &&
      $t("validation.mustBeDefaultValue", {
        field: $t("value", 1)
      })) ||
    "";

  if ((field === "value" || field === "attributeValue") && lengthExceeds(maxLengthLimit as number)) {
    return {
      isValid: false,
      feedback: $t("validation.lengthExceeds", { field, length: maxLengthLimit }),
      type: "error"
    };
  } else if (field === "value" || field === "attributeValue") {
    return {
      isValid: !isEmptyValue && !exceedsMaxLength && !notAllowedValue,
      feedback: msgforValue,
      type: "warning"
    };
  }

  if (field === "unit" && lengthExceeds(256)) {
    return {
      isValid: false,
      feedback: $t("validation.lengthExceeds", { field, length: 256 }),
      type: "error"
    };
  }

  const parser = new NumberParser(userSettings.value.CurrentLocale);
  const parsedValue = value && parser.parseLocaleStringToIndepentendNumberString(value);
  const fractionDigits = parsedValue && parsedValue.includes(".") ? parsedValue.split(".")[1].length : 0;

  // DataType validation
  if (dataType) {
    const parsedNumber = parser.parseLocaleStringToNumber(value);
    switch (dataType) {
      case "AttributeDataTypeNumerical": {
        if (value && !isValidNumber(parsedNumber, value, fractionDigits)) {
          return {
            isValid: false,
            feedback: $t("validation.dataTypeNotNumerical"),
            type: "warning"
          };
        }
        break;
      }
      case "AttributeDataTypeLogical": {
        const optionYes = $t("yes", 1, { locale: props.language.languageCode });
        const optionNo = $t("no", 1, { locale: props.language.languageCode });

        if (value && value !== "" && value !== optionYes && value !== optionNo) {
          return {
            isValid: false,
            feedback: $t("validation.dataTypeNotBoolean"),
            type: "warning"
          };
        }
        break;
      }
      case "AttributeDataTypeDate": {
        const format = language?.shortDateFormat?.toUpperCase() || null;
        if (value && format) {
          const isDateValid = moment(value, format).isValid();
          const isStrictlyValid = moment(value, format, true).isValid();
          if (!isDateValid) {
            return {
              isValid: false,
              feedback: `${$t("validation.dataTypeNotDate")} ${$t("validation.invalidDateFormat", { format })}`,
              type: "warning"
            };
          } else if (!isStrictlyValid) {
            return {
              isValid: false,
              feedback: `${$t("validation.invalidDateFormat", { format })} ${$t("validation.timeInfoNotSupported", { format })}`,
              type: "warning"
            };
          }
        }
        break;
      }
      case "Double":
      case "Decimal":
      case "Integer": {
        if (!value || !isValidNumber(parsedNumber, value, fractionDigits)) {
          return {
            isValid: false,
            feedback: $t(`validation.dataTypeNot${dataType}`),
            type: "warning"
          };
        }
        break;
      }
      default:
        break;
    }
  }

  if (
    field === "value" &&
    attributes &&
    attributes[language?.languageCode].defaultValueOnly &&
    attributes[language?.languageCode].defaultValues &&
    attributes[language?.languageCode].defaultValues.length > 0
  ) {
    if (value !== "" && attributes[language?.languageCode].defaultValues.every((x) => x.value !== value)) {
      return {
        isValid: false,
        feedback: $t("validation.mustBeDefaultValue", { field: $t("value", 1) }),
        type: "warning"
      };
    }
  }

  if (
    field === "unit" &&
    attributes &&
    attributes[language?.languageCode].defaultUnitOnly &&
    attributes[language?.languageCode].defaultUnits &&
    attributes[language?.languageCode].defaultUnits.length > 0
  ) {
    if (value !== "" && attributes[language?.languageCode].defaultUnits.every((x) => x.value !== value)) {
      return {
        isValid: false,
        feedback: $t("validation.mustBeDefaultValue", { field: $t("unit", 1) }),
        type: "warning"
      };
    }
  }

  return null;
});

const validationTooltipText = computed(() => {
  const localValidationData = validationFeedback?.value;
  const feedback = localValidationData && !localValidationData.isValid && localValidationData.feedback ? localValidationData.feedback : "";
  const isValidationFeedbackEmpty = feedback == "" || feedback === undefined ? "" : " ";
  return feedback + isValidationFeedbackEmpty;
});

const fallbackLanguageText = computed(() => {
  let fallbackLanguageText = "";
  if (userSettings.value.IsFallbackHintVisible) {
    fallbackLanguageText =
      props.valueOrFallback.isFallback && props.valueOrFallback.value
        ? $t("FallbackLanguageHintForField", { field: $t(props.field) }) + " " + getLanguageDisplayName(props.language.fallbackLanguageCode || "") + "."
        : "";
  }
  return fallbackLanguageText;
});

const validationClass = () => {
  const localValidationData = validationFeedback.value;
  return {
    border: localValidationData && !localValidationData.isValid,
    "border-warning": localValidationData && !localValidationData.isValid && localValidationData.type === "warning",
    "border-danger": localValidationData && !localValidationData.isValid && localValidationData.type === "error"
  };
};

const hasValidationError = () => {
  const localValidationData = validationFeedback?.value;
  return !viewModel.isBusy && localValidationData && !localValidationData?.isValid && localValidationData?.type == "error";
};

const getHeader = (type: string) => {
  switch (props.field) {
    case "value":
      return `value${type}`;
    case "unit":
      return `unit${type}`;
    default:
      return "";
  }
};

const handleCloseModal = (event: any) => {
  event.preventDefault();
  cleanupEditorInstance();
  emit("update:visible", false);
};

const cleanupEditorInstance = () => {
  const key = `attribute-editor-${props.language.languageCode}`;
  const editor = editorRefs[key];
  editor?.getEditor()?.remove();
};

const handleFocusIn = (e: Event) => {
  // Prevent Bootstrap dialog from blocking focusin
  if (e) {
    if (e.target) {
      document.addEventListener("focusin", (e) => {
        if ((e.target as HTMLElement).closest(".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root") !== null) {
          e.stopImmediatePropagation();
        }
      });
    }
  }
};
//#endregion
function getToolTip(value: string) {
  if (value) return value;

  if (userSettings.value.IsFallbackHintVisible === true || userSettings.value.IsFallbackHintVisible === "true")
    return `${$t("FallbackLanguageHintForField", { field: $t("value") })} ${getLanguageDisplayName(props.language.fallbackLanguageCode || "")}.`;

  return "";
}

return (_ctx: any,_cache: any) => {
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_tab = _resolveComponent("b-tab")!
  const _component_b_tabs = _resolveComponent("b-tabs")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _unref($t)('editor'),
    size: "xl",
    "modal-class": "attribute-value-editor",
    "header-close-content": "",
    visible: _ctx.visible,
    onHidden: handleCloseModal,
    onOk: onOkButtonClicked,
    "no-close-on-backdrop": "",
    "no-close-on-esc": "",
    "data-cy": "attribute-value-editor-modal"
  }, {
    "modal-footer": _withCtx(({ ok, cancel }) => [
      _createVNode(_component_b_btn, {
        onClick: ok,
        variant: "primary",
        disabled: (!canApplySuggests.value && !canApplyDefaultValues.value) || hasValidationError()
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref($t)("apply")), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "disabled"]),
      _createVNode(_component_b_btn, {
        onClick: cancel,
        disabled: viewModel.isBusy
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref($t)("Close")), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass([validationClass(), "tiny-mce-container"])
          }, [
            _createVNode(HTMLEditor, {
              id: `attribute-editor-${props.language.languageCode}`,
              ref: (x) => assignEditorRefs(x, props.language.languageCode),
              "additional-config": tinymceConfig.value,
              disabled: isReadOnly(),
              modelValue: viewModel.editedValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((viewModel.editedValue) = $event))
            }, null, 8, ["id", "additional-config", "disabled", "modelValue"])
          ], 2), [
            [_vShow, !placeholderVisible()]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(validationClass())
          }, [
            _withDirectives(_createElementVNode("div", {
              ref: "placeholder",
              class: "editor-placeholder",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (focusEditor()), ["prevent"]))
            }, null, 512), [
              [_directive_tooltip, richEditorToolTipText.value],
              [_directive_dompurify_html, props.valueOrFallback.value]
            ])
          ], 2), [
            [_vShow, placeholderVisible()]
          ])
        ])), [
          [_directive_tooltip, richEditorToolTipText.value]
        ])
      ]),
      (shouldShowSuggestions() && (viewModel.suggestValues?.length || viewModel.defaultValues?.length))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (!viewModel.isBusy)
              ? (_openBlock(), _createBlock(_component_b_tabs, { key: 0 }, {
                  default: _withCtx(() => [
                    (!props.defaultOnly && viewModel.suggestValues && viewModel.suggestValues.length > 0)
                      ? (_openBlock(), _createBlock(_component_b_tab, {
                          key: 0,
                          title: _unref($t)(getHeader('Suggest'))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(CommonFilter, {
                                modelValue: viewModel.suggestFilter,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((viewModel.suggestFilter) = $event)),
                                placeholder: _unref($t)('Filter'),
                                "trigger-by-time": ""
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                              (filteredSuggestValues.value.length)
                                ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", _hoisted_7, _toDisplayString(_unref($t)("value")), 1),
                                        _createElementVNode("th", _hoisted_8, _toDisplayString(_unref($t)("amount")), 1),
                                        _hoisted_9
                                      ])
                                    ]),
                                    _createElementVNode("tbody", _hoisted_10, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSuggestValues.value, (row) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                          key: row.attributeId
                                        }, [
                                          (row.value)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                                                _withDirectives((_openBlock(), _createElementBlock("td", {
                                                  class: _normalizeClass(["table-values-cell value-cell", { 'font-italic': !row.value }])
                                                }, [
                                                  _createTextVNode(_toDisplayString(row.value || row.fallbackValue), 1)
                                                ], 2)), [
                                                  [_directive_tooltip, getToolTip(row.value)]
                                                ]),
                                                _createElementVNode("td", _hoisted_12, _toDisplayString(row.count > 0 ? row.count : ""), 1),
                                                _createElementVNode("td", _hoisted_13, [
                                                  _withDirectives((_openBlock(), _createBlock(_component_b_btn, {
                                                    class: "btn-icon mono",
                                                    onClick: _withModifiers(($event: any) => (applySuggest(row.value)), ["prevent"]),
                                                    disabled: !row.value || !canApplySuggests.value
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_14
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick", "disabled"])), [
                                                    [_directive_tooltip, _unref($t)('translation.applySuggestion')]
                                                  ])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128))
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock(EmptyState, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", _hoisted_15, [
                                        _createTextVNode(_toDisplayString(_unref($t)("noMatches")), 1),
                                        _createElementVNode("strong", _hoisted_16, _toDisplayString(viewModel.suggestFilter), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }))
                            ])
                          ]),
                          _: 1
                        }, 8, ["title"]))
                      : _createCommentVNode("", true),
                    (viewModel.defaultValues && viewModel.defaultValues.length > 0)
                      ? (_openBlock(), _createBlock(_component_b_tab, {
                          key: 1,
                          title: _unref($t)(getHeader('Default'))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(CommonFilter, {
                                modelValue: viewModel.defaultFilter,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((viewModel.defaultFilter) = $event)),
                                placeholder: _unref($t)('Filter'),
                                "trigger-by-time": ""
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              (filteredDefaultValues.value.length)
                                ? (_openBlock(), _createElementBlock("table", _hoisted_19, [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", _hoisted_20, _toDisplayString(_unref($t)("value")), 1),
                                        _hoisted_21
                                      ])
                                    ]),
                                    _createElementVNode("tbody", _hoisted_22, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDefaultValues.value, (row) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, {
                                          key: row.attributeId
                                        }, [
                                          (row.value || row.fallbackValue)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                                                _withDirectives((_openBlock(), _createElementBlock("td", {
                                                  class: _normalizeClass([{ 'font-italic': !row.value }, "table-values-cell value-cell"])
                                                }, [
                                                  _createTextVNode(_toDisplayString(row.value || row.fallbackValue), 1)
                                                ], 2)), [
                                                  [_directive_tooltip, getToolTip(row.value)]
                                                ]),
                                                _createElementVNode("td", _hoisted_24, [
                                                  _withDirectives((_openBlock(), _createBlock(_component_b_btn, {
                                                    class: "btn-icon mono",
                                                    onClick: _withModifiers(($event: any) => (applySuggest(row.value)), ["prevent"]),
                                                    disabled: !row.value || !canApplyDefaultValues.value
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_25
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick", "disabled"])), [
                                                    [_directive_tooltip, _unref($t)('translation.applySuggestion')]
                                                  ])
                                                ])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128))
                                    ])
                                  ]))
                                : (_openBlock(), _createBlock(EmptyState, { key: 1 }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("p", _hoisted_26, [
                                        _createTextVNode(_toDisplayString(_unref($t)("noMatches")), 1),
                                        _createElementVNode("strong", _hoisted_27, _toDisplayString(viewModel.defaultFilter), 1)
                                      ])
                                    ]),
                                    _: 1
                                  }))
                            ])
                          ]),
                          _: 1
                        }, 8, ["title"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createVNode(Spinner)
                ]))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "visible"]))
}
}

})